import { render, staticRenderFns } from "./BranchSettlementSummary.vue?vue&type=template&id=69084796&"
import script from "./BranchSettlementSummary.vue?vue&type=script&lang=js&"
export * from "./BranchSettlementSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports